import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

const NotFound = () => {
  return (
    <Container maxWidth="sm">
      <Stack
        height="100vh"
        alignItems="center"
        justifyContent="center"
        rowGap={2}
      >
        <Typography variant="h5" fontWeight={700}>
          Página não encontrada
        </Typography>
        <Typography fontWeight={500}>
          Não foi possível encontrar o site que está tentando acessar.
        </Typography>
      </Stack>
    </Container>
  );
};

export default NotFound;
